export default "__VITE_ASSET__8f30a9be__"